module.exports = __webpack_public_path__ + "img/logo.cf535e08.png";